import LayoutCarouselStaticSlide from './LayoutCarouselStaticSlide';

export default LayoutCarouselStaticSlide;
